
import ListSubheader from '@mui/material/ListSubheader';
import NavigationItem from './NavigationItem';
import { INavigationGroup, INavigationItem } from './NavigationItems';
import { useAuth } from '../hooks/useAuth';
import { Status } from '../hooks/useFetch';
import { SourceMarketFields } from '@aviation/catering-masterdata-sdk';

export interface INavigationGroupProps extends INavigationGroup {
    sourceMarket?: SourceMarketFields;
    sourceMarketStatus?: Status;
}

function NavigationItemGroup(props: INavigationGroupProps) {
    const { label, children, sourceMarket, sourceMarketStatus } = props;
    const auth = useAuth();

    // While the source market (and its feature flags) hasn't loaded yet, we don't know
    // whether flag-dependent items should show, so hide them rather than flash the wrong ones.
    const isLoadingFlags = sourceMarketStatus !== undefined && sourceMarketStatus !== Status.Fetched;

    const isVisible = (item : INavigationItem) => {
        let result = ((item.administration ?? false) === false && (item.superadmin ?? false) === false) || ((item.administration ?? true) && auth.isAdministrator && (item.superadmin ?? false) === false)
        || auth.isSuperAdmin;

        if(item.featureFlag)
            result = result && !isLoadingFlags && (sourceMarket as any)?.[item.featureFlag] === true;

        if(item.hiddenByFeatureFlag)
            result = result && !isLoadingFlags && (sourceMarket as any)?.[item.hiddenByFeatureFlag] !== true;

        return result;
    }

    return (
        <>
            <ListSubheader>{label}</ListSubheader>
            {children.filter(o => isVisible(o)).map((item) => <NavigationItem key={item.id} sourceMarket={sourceMarket} sourceMarketStatus={sourceMarketStatus} {...item} />)}
        </>
    );
}

export default NavigationItemGroup;
